import ToggleSwitch from '../../../atoms/ToogleSwitch';
import { BillingConfig } from '../types/operations';

export const EMPTY_BILLING_CONFIG: BillingConfig = {
    generate_billets: null,
    automatic_preventive_collection: null,
    automatic_overdue_collection: null,
};

interface Props {
    value: BillingConfig;
    onChange: (updated: BillingConfig) => void;
    disabled?: boolean;
}

const FIELDS: Array<{ id: keyof BillingConfig; label: string }> = [
    { id: 'generate_billets', label: 'Gerar boletos para cobrança' },
    { id: 'automatic_preventive_collection', label: 'Cobrança preventiva automática' },
    { id: 'automatic_overdue_collection', label: 'Cobrança de vencidos automática' },
];

const BillingConfigSection: React.FC<Props> = ({ value, onChange, disabled }) => {
    return (
        <>
            <h2 className="text-xl font-semibold mt-4 mb-4 dark:text-white">Configuração de cobrança</h2>
            <div className="grid grid-cols-12 gap-4 mb-6">
                {FIELDS.map(({ id, label }) => (
                    <div key={id} className="col-span-4 flex items-center gap-3">
                        <ToggleSwitch
                            checked={value[id] === true}
                            onChange={(checked) => onChange({ ...value, [id]: checked })}
                            disabled={disabled}
                        />
                        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            {label}
                        </label>
                        {value[id] !== null && (
                            <span className={`text-xs font-bold ${value[id] ? 'text-blue-600 dark:text-blue-400' : 'text-red-600 dark:text-red-400'}`}>
                                {value[id] ? 'Sim' : 'Não'}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

export default BillingConfigSection;
